import {required} from "vuelidate/lib/validators";  
const StrMailTemplate = {
    data() {
      return { 
        StrMailTemplateData:{  
          Tanim:null,
          Baslik:null,
          Mesaj:null,
          Kod:null
        },  
          FormDataType:{
            Tanim:{FieldName:"Tanim",Field:"input",FieldTitle:"Tanım",FieldType:"text"},
            Baslik:{FieldName:"Baslik",Field:"input",FieldTitle:"Başlık",FieldType:"text"},
            Mesaj:{FieldName:"Mesaj",Field:"textarea",FieldTitle:"Mesaj"}, 
            Kod:{FieldName:"Kod",Field:"input",FieldTitle:"Kod",FieldType:"text"},
          }  
      } 
    },
    validations:{ 
      FormData: {
        Tanim: { required },  
          Baslik: { required }, 
          Mesaj: { required }, 
          Kod: { required },  
      } 
  },
}
export default StrMailTemplate